import axios from "axios";
export const baseURL = "https://slms.moha.co.in/";

export const api = (method, path, data,type) => {
    if (method != 'get') {
    //   const Token=getLocal("Token");
      let url = `${baseURL + path}`
      // console.log('post url',url)
      return new Promise((resolve, reject) => {
        console.log(`${method} url------------->>>>>`,url);
        axios({
          method: method,
  
          url: url,
          
          headers: {
            'Content-Type':type!=undefined? 'multipart/form-data': 'application/json',
            // Authorization: token ? `Bearer ${Token}` : '',
          },
          data: data,
          responseType: 'json',
        })
          .then(
            res => {
              console.log(`${method} url------------->>>>>`,JSON.stringify(res));
              resolve(res.data);
            },
            err => {
              console.log(`${method} url------------->>>>>`,err);
              reject(err);
            },
          )
          .catch(err => {
            console.log(`${method} url------------->>>>>`,err);
            reject(err);
          });
      });
    } else if (method === 'get') {
      return new Promise((resolve, reject) => {
        // const Token=getLocal("Token");
        let url = `${baseURL + path}`
      //  console.log("Get url------------->>>>>",url)
        axios
          .get(url, {
            params: data,
            headers:{
              'Content-Type': 'application/json',
            // Authorization: token ? `Bearer ${Token}` : '',
            }
          })
          .then(
            res => {
              // console.log("Get url------------->>>>>",JSON.stringify(res));
              resolve(res);
            },
            err => {
              // console.log("Get url------------->>>>>",err)
              reject(err);
            },
          )
          .catch(err => {
            // console.log("Get url------------->>>>>",err)
            reject(err);
          });
      });
    }
  };
    
export default api;